import script from "./CoinTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./CoinTooltip.vue?vue&type=script&setup=true&lang=js"

import "./CoinTooltip.vue?vue&type=style&index=0&id=619b541c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-619b541c"]])

export default __exports__